import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RestService } from '@app/core/api/rest.service';
import { KeyValue, PayloadKeyValueStringList, PayloadTextbaustein, PayloadTextbausteinResultList } from '@pezi/entities';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RestTexteService extends RestService {

  constructor(protected http: HttpClient) {
    super(http);
  }

  searchTexte(searchParams: KeyValue<string, any>[]): Observable<PayloadTextbausteinResultList> {
    const params = this.getKeyValueAsQueryParams(searchParams);
    const options = Object.assign({}, this.httpOptions,
      {params});
    return this.http
      .get<PayloadTextbausteinResultList>(
        this.baseUrl + '/texte/suche',
        options);
  }

  public getTextarten(): Observable<PayloadKeyValueStringList> {
    return this.http
      .get<PayloadKeyValueStringList>(this.baseUrl + '/texte/textarten', this.httpOptions);
  }

  public getTextDetail(art: string, txtId: string, sprache: string): Observable<PayloadTextbaustein> {
    const params = this.getKeyValueAsQueryParams([
      {
        key:   'art',
        value: art
      },
      {
        key:   'txtId',
        value: txtId
      },
      {
        key:   'sprache',
        value: sprache
      }
    ] as KeyValue<string, any>[]);
    const options = Object.assign({}, this.httpOptions,
      {params});
    return this.http
      .get<PayloadTextbaustein>(this.baseUrl + '/texte', options);
  }

  public getTextDetailPdf(art: string, txtId: string, sprache: string): Observable<HttpResponse<Blob>> {
    const params = this.getKeyValueAsQueryParams([
      {
        key:   'art',
        value: art
      },
      {
        key:   'txtId',
        value: txtId
      },
      {
        key:   'sprache',
        value: sprache
      }
    ] as KeyValue<string, any>[]);
    const options = Object.assign({}, this.httpOptions,
      {params});
    return this.http
      .get<Blob>(this.baseUrl + '/texte/druck', {
        ...options,
        observe:      'response',
        responseType: 'blob' as 'json'
      });
  }
}
